import type { MonitorPreference } from '@tunasong/schemas'

/** What the editor needs to offer Undo after a row is deleted */
export interface RowRemoval {
  message: string
  onUndo(): void
}

/** Who brings it, written from the member's point of view */
export const whoOptions = [
  { value: 'artist', label: 'I bring it' },
  { value: 'venue', label: 'Venue provides' },
] as const

/** Focus key of an input row, so the editor can move focus to rows it adds */
export const inputRowKey = (id: string) => `input:${id}`

/** Monitoring, as the member and the lead choose it */
export const monitorOptions = [
  { value: 'wedge', label: 'Wedge' },
  { value: 'iem', label: 'In-ears' },
  { value: 'both', label: 'Both' },
  { value: 'none', label: 'None' },
] as const satisfies readonly { value: MonitorPreference; label: string }[]
